import React from 'react';
import { Button } from '@eventbrite/marmalade';
import { defineMessage, FormattedMessage, useIntl } from 'react-intl';
import styles from './StaticMap.module.scss';
import { LISTING_HEAP_IDS } from '@/components/_shared/constants';
import Image from 'next/image';
import mapImage from './map.png';

export const EVENT_LOCATION_MAP_ID = 'event-location-map';

export const StaticMap: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  const { formatMessage } = useIntl();
  return (
    <div className={styles.staticMap}>
      <Image key="static-map-image" className={styles.mapImage} src={mapImage} alt="Map" />
      <Button
        className={styles.showMapButton}
        variant="secondary"
        onClick={onClick}
        sizeVariant="medium"
        aria-label={formatMessage(
          defineMessage({ id: 'Show interactive map', defaultMessage: 'Show interactive map' }),
        )}
        aria-controls={EVENT_LOCATION_MAP_ID}
        data-heap-id={LISTING_HEAP_IDS.SHOW_MAP}
      >
        <FormattedMessage id="Show map" />
      </Button>
    </div>
  );
};
